<template>
  <div
    style="
      background-color: #edeffc;
      padding: 20px;
      padding-bottom: 120px;
      box-sizing: border-box;
      text-align: left;
    "
  >
    <div class="title">
      设备号:
      <span class="num">
        {{ detail.virtualNumber ? detail.virtualNumber : meCardNum }}
      </span>
      <van-tag
        plain
        style="margin-left: 10px; background-color: transparent"
        type="primary"
      >
        <div v-if="detail.state == -1">未知</div>
        <div v-if="detail.state == 0">正常</div>
        <div v-if="detail.state == 1">单项停机</div>
        <div v-if="detail.state == 2">停机</div>
        <div v-if="detail.state == 3">预销号</div>
        <div v-if="detail.state == 4">销号/拆机</div>
        <div v-if="detail.state == 5">过户</div>
        <div v-if="detail.state == 6">休眠</div>
        <div v-if="detail.state == 7">待激活</div>
        <div v-if="detail.state == 8">已停用</div>
        <div v-if="detail.state == 9">库存</div>
        <div v-if="detail.state == 10">已失效</div>
        <div v-if="detail.state == 11">违章停机</div>
        <div v-if="detail.state == 12">挂失</div>
        <div v-if="detail.state == 13">用户报停</div>
        <div v-if="detail.state == 14">不存在</div>
        <div v-if="detail.state == 15">低速</div>
        <div v-if="detail.state == 16" class="names">可测试</div>
      </van-tag>
      <span
        v-if="form.electricQuantity && form.electricQuantity >= 30"
        style="
          color: green;
          font-size: 12px;
          font-weight: 500;
          margin-left: 5px;
        "
      >
        电量：{{ form.electricQuantity }}%
      </span>
      <span
        v-if="form.electricQuantity && form.electricQuantity < 30"
        style="color: red; font-size: 12px; font-weight: 500; margin-left: 5px"
      >
        电量：{{ form.electricQuantity }}%
      </span>
    </div>
    <div class="detail">
      <img src="@/components/WIFI-01.png" alt="" />
      <div class="right">
        <div class="text">
          <img src="@/components/router.png" alt="" />
          <span>
            设备状态：
            <span class="color">
              {{
                form.equiState == -1
                  ? "未知"
                  : form.equiState == 0
                  ? "在线"
                  : "离线"
              }}
            </span>
          </span>
        </div>
        <div class="text">
          <img src="@/components/_wifi.png" alt="" />
          <span>
            设备信号：
            <span class="color">
              {{ form.rssi }}格
              <!-- <ul>
                <li
                  v-for="i in 4"
                  :key="i"
                  :style="{
                    background:
                      '' +
                      (i <= form.rssi ? '#5cf548' : 'rgba(0, 0, 0, 0.4)') +
                      '',
                  }"
                ></li>
              </ul> -->
            </span>
          </span>
        </div>
        <div class="text">
          <img src="@/components/link-three.png" alt="" />
          <span>
            推送时间：
            <span class="color">
              {{ form.theFinalTime ? form.theFinalTime : "-----------" }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="details">
      <div class="display">
        <div class="right">
          <van-form label-width="68px" @submit="onSubmit">
            <div class="border">
              <van-field
                v-model="form.equiName"
                name="用户名"
                label="WIFI名称:"
                placeholder="请填写WIFI名称"
              ></van-field>
            </div>
            <div class="border">
              <van-field
                v-model="form.pwd"
                name="用户名"
                label="WIFI密码:"
                placeholder="请填写WIFI密码"
              ></van-field>
            </div>
          </van-form>
        </div>
        <img class="img" src="@/components/wifiw.png" alt="" />
      </div>
      <div class="display" style="margin-top: 10px">
        <van-button
          type="primary"
          @click="onSubmit"
          color="#A0BBF2"
          round
          size="mini"
        >
          保存修改
        </van-button>
        <van-button
          type="primary"
          @click="reconnection"
          color="#A0BBF2"
          round
          size="mini"
        >
          重启设备
        </van-button>
        <van-button
          type="primary"
          @click="init"
          color="#A0BBF2"
          round
          size="mini"
        >
          恢复出厂
        </van-button>
      </div>
    </div>

    <div class="details">
      <div style="display: flex; align-items: center; font-size: 14px">
        <div class="round"></div>
        <span style="margin-left: 10px">网络优选</span>
      </div>
      <div v-for="item in listS" :key="item.id" class="content">
        <div
          style="
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              v-if="item.name == '中国电信'"
              class="icons"
              src="@/assets/YM-DX.png"
            />
            <img
              v-if="item.name == '中国联通'"
              class="icons"
              src="@/assets/YM-LT.png"
            />
            <img
              v-if="item.name == '三网通'"
              class="icons"
              src="@/assets/YM-SWT.png"
            />
            <img
              v-if="item.name == '中国移动'"
              class="icons"
              src="@/assets/YM-YD.png"
            />
            <img
              v-if="item.name == '中国广电'"
              class="icons"
              src="@/assets/zggd1.png"
            />
            <van-tag
              plain
              v-if="item.value == 0"
              style="margin-left: 10px; background-color: transparent"
              type="primary"
            >
              已实名
            </van-tag>
            <van-tag
              plain
              v-if="item.value == 1"
              style="margin-left: 10px; background-color: transparent"
              type="primary"
            >
              未实名
            </van-tag>
            <van-tag
              plain
              v-if="item.value == -1"
              style="margin-left: 10px; background-color: transparent"
              type="danger"
            >
              未知
            </van-tag>
            <van-tag
              plain
              v-if="item.name == radios"
              style="margin-left: 10px; background-color: transparent"
              type="primary"
            >
              在用
            </van-tag>
          </div>
          <el-radio
            style="float: right; margin-top: 2px"
            v-model="radio"
            size="medium"
            :label="item.name"
            :disabled="detail.ordersModel ? false : true"
            @change="edit"
          >
            <br />
          </el-radio>
        </div>
      </div>
    </div>
    <div class="details">
      <div style="display: flex; align-items: center; font-size: 14px">
        <div class="round"></div>
        <span style="margin-left: 10px">温馨提示</span>
      </div>
      <div class="text">1.计划切换网络时，请务必完成相应运营商的实名认证。</div>
      <div class="text">2.在修改密码或切换网络后，请等待5分钟并重新登录。</div>
    </div>
    <!-- 官方实名提示 -->
    <van-popup
      style="font-size: 16px; width: 84%"
      v-model="offAlerts"
      :close-on-click-overlay="false"
      round
    >
      <div style="padding-top: 15px; text-align: center">温馨提示</div>
      <div style="padding: 15px">
        您未官方实名，请立即进行官方实名操作，官方实名后才可以使用，若已实名请点击刷新获取最新实名状态
        <span style="color: #1890ff" @click="getRealName(details.id)">
          [点此刷新]
        </span>
      </div>
      <div
        style="
          box-sizing: border-box;
          width: 100%;
          padding: 13px;
          color: red;
          text-align: center;
          border-top: 1px solid #cccccc;
        "
        @click="opi"
      >
        立即实名
      </div>
    </van-popup>
    <Tab></Tab>
  </div>
</template>

<script>
  import { realAddress, getThirdPartyUrl } from "@/api/user/index.js";
  import {
    phoneSimCard,
    updateFalseOp,
    phoneSimCarda,
    getRealName,
    clientGets,
  } from "../api/cardOperation";
  import {
    getEquipment,
    updatePwdAndName,
    init,
    reconnection,
  } from "@/api/user/index.js";
  import Tab from "@/components/Tab.vue";
  import { clientGet } from "../api/seting/index";
  import { Loading } from "element-ui";
  export default {
    data() {
      return {
        detail: {},
        cc: [],
        kefuurl: "",
        form: {},
        mk: "",
        radios: "",
        listS: [],
        details: {},
        offAlerts: false,
        three: [
          {
            id: 1,
            name: "中国移动",
          },
          {
            id: 2,
            name: "中国联通",
          },
          {
            id: 3,
            name: "中国电信",
          },
          {
            id: 5,
            name: "中国广电",
          },
        ],
        radio: "",
      };
    },
    created() {
      Loading.service();
    },
    mounted() {
      this.phoneSimCard();
      this.url();
    },
    components: {
      Tab,
    },
    methods: {
      getRealName(val) {
        const ste = this.$toast.loading({
          message: "正在更新数据，请稍后...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        getRealName(val)
          .then((res) => {
            if (res.status) {
              ste.clear();
              this.phoneSimCard();
              s;
            }
          })
          .catch(() => {
            ste.clear();
          });
      },
      copysec() {
        // console.log(val);
        let input = document.createElement("input");
        input.value = this.details.iccId;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        // ===========================
        this.$notify({ type: "success", message: "复制成功!" });
      },
      async cop() {
        await this.copyse();
        await this.copysec();
      },
      copyse() {
        // console.log(val);
        let input = document.createElement("input");
        input.value = this.details.realNameCard;
        input.id = "creatDom";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        // ===========================
        this.$notify({ type: "success", message: "复制成功!" });
      },
      copys() {
        console.log(this.details);
        if (this.details.seriesModel.realNameType != 4) {
          if (this.details.seriesModel.realNameAlert == 1) {
            if (this.details.realNameCard) {
              this.cop();
            } else {
              this.copysec();
            }
          } else {
            if (this.details.realNameCard == undefined) {
              this.copysec();
            }
          }
        }

        if (this.details.seriesModel.realNameType == 2) {
          window.location.href = `https://ec.iot.10086.cn/authApi/service/wx/realnameH5/stepOne?channelId=RNFORWEB&iccid=${this.details.iccId}&msisdn=${this.details.realNameCard}`;
        } else if (this.details.seriesModel.realNameType == 1) {
          console.log("s");
        } else if (this.details.seriesModel.realNameType == 3) {
          console.log("s");
        } else if (this.details.seriesModel.realNameType == 4) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });
          realAddress(this.details.meCardNum)
            .then((res) => {
              if (res.status == true) {
                console.log(res);
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
              this.offAlerts = true;
            });
        } else if (this.details.realNameType == 5) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          getThirdPartyUrl(this.details.meCardNum)
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
              this.offAlerts = true;
            });
        } else {
          console.log(this.details);
          clientGets(this.details.meCardNum).then((res) => {
            if (res.status) {
              if (res.data) {
                window.location.href = res.data.realName;
              }
            }
          });
        }
      },
      opi() {
        this.offAlerts = true;
        if (this.details.realnameModel) {
          if (this.details.seriesModel.realNameJudge == 0) {
            if (this.details.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.offAlerts = true;
              this.showes = true;
            }
          } else if (
            this.details.seriesModel.realNameJudge == 1 &&
            this.details.officialRealName != 0
          ) {
            if (this.details.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.offAlerts = true;
              this.showes = true;
            }
          } else if (
            this.details.seriesModel.realNameJudge == 1 &&
            this.details.officialRealName == 0
          ) {
             if (this.details.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.offAlerts = true;
              this.showes = true;
            }
          } else if (this.details.seriesModel.realNameJudge == 2) {
            if (
              this.details.isPay == true &&
              this.details.officialRealName != 0
            ) {
              if (this.details.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.showes = true;
              }
            } else if (this.details.isPay == false) {
              this.$toast.fail("该卡未充值，请充值后再进行官方实名");
            } else if (
              this.details.isPay == true &&
              this.details.officialRealName == 0
            ) {
             if (this.details.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.showes = true;
              }
            }
          } else if (this.details.seriesModel.realNameJudge == 3) {
            if (
              this.details.isPay == true &&
              this.details.officialRealName != 0 &&
              this.details.isTheMonth == true
            ) {
              if (this.details.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
            } else if (this.details.officialRealName == 0) {
               if (this.details.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
            } else {
              this.$toast.fail("没有有效期订单，不允许官方实名");
            }
          } else if (this.details.officialRealName == 0) {
             if (this.details.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
          } else {
            this.$toast.fail("请联系管理员");
          }
        } else {
          this.$router.push({
            name: "Registers",
            params: {
              type: this.details.seriesModel.type,
              url: this.realurl,
              iccId: this.details.iccId,
              types: this.details.seriesModel.realNameType,
              realNameJudge: this.details.seriesModel.realNameJudge,
              isPay: this.details.isPay,
              isTheMonth: this.details.isTheMonth,
            },
          });
        }
      },
      //切换运营商
      edit() {
        if (this.details.falseOpMap) {
          this.details.falseOpMap.forEach((item) => {
            if (item.name == this.radio && item.value == 0) {
              updateFalseOp(this.radio, item.meCardNum).then((res) => {
                if (res.status) {
                  console.log(res);
                  this.phoneSimCard();
                  this.show = false;
                  this.$dialog
                    .confirm({
                      message:
                        "切换运营商需要耐心等待2-5分钟,切换运营商完成后，建议重启设备",
                    })
                    .then(() => {
                      // on confirm
                    })
                    .catch(() => {
                      // on cancel
                      this.radio = this.detail.name;
                    });
                }
              });
            } else if (item.name == this.radio && item.value !== 0) {
              this.$dialog
                .confirm({
                  message: "当前运营商尚未实名，请先实名后在切换",
                })
                .then(() => {
                  phoneSimCarda(item.meCardNum).then((res) => {
                    if (res.status) {
                      this.details = res.data;
                      console.log(this.details);
                      if (res.data.officialRealName != 0) {
                        if (res.data.seriesModel.realNameJudge == 0) {
                          this.offAlerts = true;
                        } else if (res.data.seriesModel.realNameJudge == 1) {
                          this.offAlerts = true;
                        } else if (
                          res.data.seriesModel.realNameJudge == 2 &&
                          res.data.isPay == true
                        ) {
                          this.offAlerts = true;
                        } else if (
                          res.data.seriesModel.realNameJudge == 3 &&
                          res.data.isPay == true &&
                          res.data.isTheMonth == true
                        ) {
                          this.offAlerts = true;
                        }
                      }
                    }
                  });
                })
                .catch(() => {
                  // on cancel
                  this.radio = this.detail.name;
                });
            }
          });
        } else {
          updateFalseOp(this.radio, "").then((res) => {
            if (res.status) {
              console.log(res);
              this.phoneSimCard();
              this.show = false;
              this.$dialog
                .confirm({
                  message:
                    "切换运营商需要耐心等待2-5分钟,切换运营商完成后，建议重启设备",
                })
                .then(() => {
                  // on confirm
                })
                .catch(() => {
                  // on cancel
                  this.radio = this.detail.name;
                });
            }
          });
        }
      },
      kefu() {
        window.location.href = this.kefuurl;
      },
      onSubmit() {
        updatePwdAndName(this.form).then((res) => {
          this.$toast(res.msg);
        });
      },
      reconnection() {
        reconnection(this.form.imei).then((res) => {
          if (res.status == true) {
            this.$toast.success(res.msg);
            this.getEquipment(this.detail.iccId);
          } else {
            this.$toast.fail(res.msg);
          }
        });
      },
      init() {
        init(this.form.imei).then((res) => {
          if (res.status == true) {
            this.$toast.success(res.msg);
            this.getEquipment(this.detail.iccId);
          } else {
            this.$toast.fail(res.msg);
          }
        });
      },
      url() {
        clientGet().then((res) => {
          if (res.status) {
            if (res.data) {
              this.kefuurl = res.data.customerService;
            }
          }
        });
      },
      getEquipment(val) {
        getEquipment(val).then((res) => {
          if (res.status) {
            this.form = res.data;
          } else {
            this.$toast.fail(res.msg);
          }
        });
      },
      router(s) {
        this.$router.push(`/detail/${s}`);
        localStorage.removeItem("next");
      },
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.listS = [];
            if (res.data.ordersModel) {
              if (res.data.ordersModel.operatorSwitch) {
                res.data.ordersModel.operatorSwitch = JSON.parse(
                  res.data.ordersModel.operatorSwitch
                );
                if (res.data.ordersModel) {
                  if (res.data.virtualNumber) {
                    if (res.data.ordersModel.operatorSwitch) {
                      res.data.ordersModel.operatorSwitch.forEach((item) => {
                        res.data.falseOpMap.forEach((itema) => {
                          this.three.forEach((items) => {
                            if (items.id == item && itema.name == items.name) {
                              this.listS.push(itema);
                            }
                          });
                        });
                      });
                    }
                  }
                } else {
                  res.data.ordersModel.operatorSwitch.forEach((item) => {
                    this.three.forEach((itema) => {
                      this.three.forEach((items) => {
                        if (items.id == item) {
                          this.listS.push(itema);
                        }
                      });
                    });
                  });
                }
              } else {
                this.listS = this.three;
              }
            } else {
              if (res.data.seriesModel.operatorSwitch) {
                res.data.seriesModel.operatorSwitch = JSON.parse(
                  res.data.seriesModel.operatorSwitch
                );
                if (res.data.seriesModel && res.data.falseOpMap) {
                  res.data.seriesModel.operatorSwitch.forEach((item) => {
                    res.data.falseOpMap.forEach((itema) => {
                      this.three.forEach((items) => {
                        if (items.id == item && itema.name == items.name) {
                          this.listS.push(itema);
                        }
                      });
                    });
                  });
                }
              } else {
                if (res.data.falseOpMap) {
                  res.data.falseOpMap.forEach((itema) => {
                    this.three.forEach((items) => {
                      if (itema.name == items.name) {
                        this.listS.push(itema);
                      }
                    });
                  });
                }
              }
            }

            this.detail = res.data;
            this.details = res.data;
            getEquipment(this.detail.iccId).then((res) => {
              Loading.service().close();
              if (res.status == true) {
                this.listS.forEach((item) => {
                  if (item.meCardNum == res.data.iccId) {
                    this.radios = item.name;
                    this.radio = item.name;
                  }
                });
                this.form = res.data;
              } else {
                this.$toast.fail(res.msg);
              }
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .signal-wrapper {
    width: 60px;
    height: 40px;
  }
  ul {
    position: relative;
    width: 100%;
    height: 100%;
  }
  li {
    width: 4px;
    position: absolute;
    bottom: 5px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.5);
  }
  ul li:nth-child(1) {
    height: 5px;
    left: 70px;
  }
  ul li:nth-child(2) {
    height: 7px;
    left: 77px;
  }
  ul li:nth-child(3) {
    height: 9px;
    left: 84px;
  }
  ul li:nth-child(4) {
    height: 11px;
    left: 91px;
  }
  .van-cell {
    padding: 10px 0px !important;
  }
  .van-button--mini {
    padding: 12px 15px !important;
    font-size: 13px !important;
    line-height: 20px;
    text-align: center !important;
  }

  .icons {
    width: 80px;
  }

  .content {
    width: 100%;
    background-color: white;
    padding: 10px 0;
    color: black;
    font-size: 14px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
  }

  .border {
    width: 90%;
    border-bottom: 1px solid #e3e3e3;
  }

  .round {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #5e77e7;
  }
  .display {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    font-size: 15px;
    font-weight: 600;
    .num {
      font-weight: 800;
    }
  }
  .details {
    border-radius: 10px;
    background-color: #fff;
    margin-top: 20px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
    box-sizing: border-box;
    padding: 15px;
    .img {
      width: 70px;
      height: 70px;
    }
    .text {
      font-size: 14px;
      margin-top: 10px;
    }
  }
  .detail {
    border-radius: 10px;
    background-color: #fff;
    height: 110px;
    margin-top: 20px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 70px;
      height: 70px;
    }
    .right {
      width: 70%;
      .text {
        width: 100%;
        font-size: 13px;
        line-height: 25px;
        border-bottom: 1px solid #e3e3e3;
        display: flex;
        align-items: center;
        img {
          width: 13px;
          height: 13px;
          margin-right: 5px;
        }
        .color {
          color: green;
        }
      }
    }
  }
</style>
